/**
 * デバイスがモバイルかどうかを検出するユーティリティ
 */

// モバイルデバイスかどうかを判定
export const isMobile = typeof window !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

// iOSデバイスかどうかを判定
export const isIOS = typeof window !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent);

// Androidデバイスかどうかを判定
export const isAndroid = typeof window !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * モバイル/タブレットデバイス判定
 * SSR安全で、iPadOS 13+（User AgentがMacintoshになる）にも対応
 */
export function isMobileOrTablet(): boolean {
  if (typeof navigator === "undefined") return false;

  // 一般的なモバイル/タブレットのUser Agent
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }

  // iPadOS 13+ (User Agent が Macintosh になる)
  // タッチ対応かつ Macintosh の場合は iPad と判定
  if (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1) {
    return true;
  }

  return false;
} 